<script lang="ts" context="module">
    export type SpinnerSize = 'xl' | 'lg' | 'md' | 'sm' | 'xs' | null;
</script>

<script lang="ts" generics="TransitionInConfig, TransitionOutConfig">
    import { cx } from '$lib/utils/cx.js';
    import { match } from 'ts-pattern';
    import Div from '$components/Transition/Div.svelte';
    import type { TransitionsInOut } from '$lib/utils/transition.js';
    import * as t from '$trans';
    import { getContainer } from '$components/Context/ContainerContext';

    const { lang } = getContainer();

    let className = '';
    export { className as class };

    export let loading: boolean = true;

    export let transitions: TransitionsInOut<TransitionInConfig, TransitionOutConfig> =
        {};

    export let size: SpinnerSize = null;
    let sizeClass: string = match(size)
        .with(null, () => '')
        .with('xl', () => 'spinner-xl')
        .with('lg', () => 'spinner-lg')
        .with('md', () => 'spinner-md')
        .with('sm', () => 'spinner-sm')
        .with('xs', () => 'spinner-xs')
        .exhaustive();
</script>

{#if loading === true}
    <Div class={cx('spinner-border', sizeClass, className)} {transitions}>
        <span class="sr-only"> {t.ui.loading_etc({}, $lang)} </span>
    </Div>
{/if}
